"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_1 = require("vue");
const type_1 = __importDefault(require("./type"));
exports.default = (0, vue_1.defineComponent)({
    name: 'ExceptionPage',
    props: {
        type: {
            type: String,
            default: '404',
        },
    },
    data() {
        return {
            config: type_1.default
        };
    },
    methods: {
        handleToHome() {
            this.$router.push('/');
        },
    },
});
